import React from 'react';
import './LegalPages.css';

const TermsOfService = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <h1>Terms of Service</h1>
        <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>
        
        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using Cure8 Studios services, you accept and agree to be bound by the terms and
            provisions of this agreement.
          </p>
        </section>

        <section>
          <h2>2. Use License</h2>
          <p>
            Permission is granted to temporarily use Cure8 Studios services for personal, non-commercial
            transitory viewing only.
          </p>
        </section>

        <section>
          <h2>3. Service Availability</h2>
          <p>We strive to maintain high service availability but do not guarantee uninterrupted access to our services.</p>
        </section>

        <section>
          <h2>4. User Responsibilities</h2>
          <p>Users are responsible for maintaining the confidentiality of their account information and for all activities that occur under their account.</p>
        </section>

        <section>
          <h2>5. Limitation of Liability</h2>
          <p>
            In no event shall Cure8 Studios be liable for any indirect, incidental, special, consequential, or
            punitive damages.
          </p>
        </section>

        <section>
          <h2>6. Contact Information</h2>
          <p>For questions about these Terms of Service, contact us at legal@cure8studios.com</p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;
